export default "__VITE_ASSET__BkS$4Qsk__"